<template>
  <nav>
    <a href="http://shop.pantaloni.online" target="_blank">Shop</a>
    <router-link v-if="!showInfo" :to="{ path: '/info' }">Info</router-link>
    <router-link v-else :to="{ path: '/' }">Close</router-link>
  </nav>
</template>

<script>
export default {
  name: 'Menu',
  props: ['data', 'showInfo'],
}
</script>

<style lang="scss">
nav {
  position: fixed;
  z-index: 105;
  bottom: .25em;
  left: 50%;
  transform: translateX(-50%);
  font-size: 2.8vw;
  @media screen and (orientation: portrait) {
    font-size: 7vw;
  }
  font-weight: 600;
  a {
    margin: 0 0.5em;
  }
  a, a:hover, a:visited, a:active, a:focus {
    border-bottom: none;
  }
}
</style>
